import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class Kraken1PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.KRAKEN1;
}

export default Kraken1PoiTileEntity;
